import * as XLSX from "xlsx";
var FileSaver = require("file-saver");
export const DownloadFile = (jsonData, filename) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = XLSX.utils.json_to_sheet(jsonData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

export const BlobToDownloadFile = (blobData, filename, fileType) => {
  FileSaver.saveAs(
    new Blob([blobData], {
      type: fileType === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename
  );
};
export const URLToDownloadFile = (url, filename) => {
  FileSaver.saveAs(url, filename);
};

export const GetAllNumbersBetween = (x, y) => {
  var numbers = [];
  for (var i = x; i <= y; i++) {
    numbers.push(i);
  }
  return numbers;
};
